import React from "react";
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip, Box } from "@mui/material";
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';

const ShipmentRate = ({ 
    billed_rate = null, 
    billed_currency_code = "", 
    api_rate = null, 
    api_currency_code = "", 
    is_multi_piece = null, 
    is_voided = null 
}) => {
    const multi_piece = Boolean(is_multi_piece);
    const voided = Boolean(is_voided);

    if (voided) {
        return <>-</>;
    }

    // Helper function to validate numerical values
    const isValidNumber = (val) => {
        return val !== null && val !== "" && val !== "-" && val !== undefined && !isNaN(val);
    };

    if (isValidNumber(billed_rate)) {
        return (
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
                <span>{parseFloat(billed_rate).toFixed(2)}</span>
                {billed_currency_code && (
                    <Box component="span" sx={{ fontSize: '11px', color: '#64748B', fontWeight: 500 }}>
                        {billed_currency_code}
                    </Box>
                )}
                {multi_piece && (
                    <Tooltip title="Multi piece shipment rate" placement="right-start">
                        <QuizOutlinedIcon color="warning" sx={{ ml: 0.5, alignSelf: 'center' }} fontSize="small" />
                    </Tooltip>
                )}
            </Box>
        );
    } 
    
    if (isValidNumber(api_rate)) {
        return (
            <Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
                <span>{parseFloat(api_rate).toFixed(2)}</span>
                {api_currency_code && (
                    <Box component="span" sx={{ fontSize: '11px', color: '#64748B', fontWeight: 500 }}>
                        {api_currency_code}
                    </Box>
                )}
                <Tooltip title="This is excluding tax and may change if there is any dimensional / weight adjustment" placement="right-start">
                    <InfoIcon sx={{ ml: 0.5, color: '#919eab', alignSelf: 'center' }} fontSize="small" />
                </Tooltip>
                {multi_piece && (
                    <Tooltip title="Multi piece shipment rate" placement="right-start">
                        <QuizOutlinedIcon color="warning" sx={{ ml: 0.5, alignSelf: 'center' }} fontSize="small" />
                    </Tooltip>
                )}
            </Box>
        );
    }

    return <>-</>;
};

export default ShipmentRate;